export const ADMIN = 'admin'
export const EXPERT = 'employee'
export const CONSEQUENCES = 'curator_additional'
export const FOREIGN = 'curator_foreign'
